import { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { getLogo, getPolicy } from '../services/Firebase';
import LanguageSelector from '../components/LanguageSelector';
const _ = require('lodash');

// @src/pages/Policy.jsx
const Policy = () => {
    const { id, lang } = useParams();
    const [ lng, setLng ] = useState(lang || 'es');
    const [datas, setDatas] = useState({});
    const [img, setImg] = useState();

    useEffect(()=>{
        async function getImg() {
            setImg(await getLogo(id));
        };
        getImg();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(()=>{
        getData(lng);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lng]);

    const getData = async (lng) => {
        const ouch = _.cloneDeep(datas);
        if(ouch[lng] == null || ouch[lng].length <= 0) {
            const policy = await getPolicy(id, lng);
            ouch[lng] = policy;
            setDatas(ouch);
        }
    }

    let mystyle = {
        with: '100%'
    };
    if(id === 'racvn') {
        mystyle.backgroundColor = '#F8DA4B';
        mystyle.border = 'solid 1px #F8DA4B'
    }

    const mt = id==='racvn' ? 0 : 10;

    return (
        <div style={mystyle}>
            <div style={{maxWidth: '700px', margin: '0 auto'}} >
                <LanguageSelector onLanguageChange={setLng} lang={lng} />
                <div style={{with: '100%', textAlign: 'center', maxHeight: '220px', marginTop: mt+'px', marginBottom: '10px'}}>
                    <img src={img} alt={id} style={{maxHeight: '200px'}} />
                </div>
                {datas[lng] && datas[lng].lines.map((element, index) => (
                    <div key={index} dangerouslySetInnerHTML={{ __html: element }} />
                ))}
            </div>
        </div>
    );
  };
  export default Policy;